import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { FormattedMessage, injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import Notifications from 'react-notification-system-redux'
import * as formatters from '../../../common/formatters'

import PermissionsCheck from '../../auth/components/PermissionsCheck'

import { PERMS } from '../permissions'
import Dropzone from "react-dropzone"
import * as customersActionCreators from "../actionCreators"
import * as selectors from "../selectors"
import { LoadingOverlay } from "../../../common/loading_overlay"
import { SelectField } from "../../../common/form";

class CustomersImport extends Component {
    stepNames = {
        1: this.props.intl.formatMessage({ id: 'modules.customersImport.stepNames.1' }),
        2: this.props.intl.formatMessage({ id: 'modules.customersImport.stepNames.2' }),
        3: this.props.intl.formatMessage({ id: 'modules.customersImport.stepNames.3' })
    }

    columnTypes = {
        'regNumber': this.props.intl.formatMessage({ id: 'modules.customersImport.columnTypes.regNumber' }),
        'vatNumber': this.props.intl.formatMessage({ id: 'modules.customersImport.columnTypes.vatNumber' }),
        'name': this.props.intl.formatMessage({ id: 'modules.customersImport.columnTypes.name' }),
        'nameTransporeon': this.props.intl.formatMessage({ id: 'modules.customersImport.columnTypes.nameTransporeon' }),
        'defaultCurrency': this.props.intl.formatMessage({ id: 'modules.customersImport.columnTypes.defaultCurrency' }),
        'invoiceDeadlineDays': this.props.intl.formatMessage({ id: 'modules.customersImport.columnTypes.invoiceDeadlineDays' }),
        'emailForInvoicing': this.props.intl.formatMessage({ id: 'modules.customersImport.columnTypes.emailForInvoicing' }),
        'invoicingNote': this.props.intl.formatMessage({ id: 'modules.customersImport.columnTypes.invoicingNote' }),
        'limitUnpaidInvoices': this.props.intl.formatMessage({ id: 'modules.customersImport.columnTypes.limitUnpaidInvoices' }),
        'limitOverdueInvoices': this.props.intl.formatMessage({ id: 'modules.customersImport.columnTypes.limitOverdueInvoices' }),
        'blocked': this.props.intl.formatMessage({ id: 'modules.customersImport.columnTypes.blocked' }),
        'businessManager': this.props.intl.formatMessage({ id: 'modules.customersImport.columnTypes.businessManager' }),
        'dispatcher': this.props.intl.formatMessage({ id: 'modules.customersImport.columnTypes.dispatcher' }),
        'transportPlanCount': this.props.intl.formatMessage({ id: 'modules.customersImport.columnTypes.transportPlanCount' }),
        'transportPlanValue': this.props.intl.formatMessage({ id: 'modules.customersImport.columnTypes.transportPlanValue' }),
        'transportPlanMargin': this.props.intl.formatMessage({ id: 'modules.customersImport.columnTypes.transportPlanMargin' }),
        'speditionPlanCount': this.props.intl.formatMessage({ id: 'modules.customersImport.columnTypes.speditionPlanCount' }),
        'speditionPlanValue': this.props.intl.formatMessage({ id: 'modules.customersImport.columnTypes.speditionPlanValue' }),
        'speditionPlanMargin': this.props.intl.formatMessage({ id: 'modules.customersImport.columnTypes.speditionPlanMargin' }),
    }

    state = {
        step: 1,
        importHeaders: [],
        importFileId: null,
        importFileName: null,
        importItems: [],
        importItemValues: [],
        columnTypes: {},
        defaultLocale: null,
        importAllItemsChecked: false
    }

    importProcessing = false

    onDropFiles = files => {
        files.forEach(file => {
            const reader = new FileReader()
            const fileName = file.name

            reader.onload = e => {
                const loadedFile = {
                    name: fileName,
                    base64: e.target.result,
                }
                this.props.actions.fetchCustomersImportHeaders(loadedFile)
            }

            reader.readAsDataURL(file)
        })
    }

    onBackButtonClick = () => {
        this.setState({
            ...this.state,
            step: this.state.step - 1
        })
    }

    onSummaryButtonClick = () => {
        this.props.actions.fetchCustomersImportItems(this.state.importFileId, this.state.columnTypes)
    }

    setColumnType = (id, value) => {
        this.setState({
            columnTypes: {
                ...this.state.columnTypes,
                [id]: value
            }
        })
    }


    onImportItemChange = (key, value) => {
        this.setState({
            importItemValues: {
                ...this.state.importItemValues,
                [key]: value
            }
        })
    }

    onImportAllItemsChange = (value) => {
        this.setState({
            importAllItemsChecked: value
        })

        var importItemValues = {};

        for (var key in this.state.importItemValues) {
            importItemValues[key] = value
        }

        this.setState({
            importItemValues: importItemValues
        })
    }

    onImportButtonClick = () => {
        this.importProcessing = true
        this.props.actions.importCustomers(this.state.importFileId, this.state.columnTypes, this.state.importItemValues)
    }

    componentWillMount() {

    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.importInProgress && !nextProps.importInProgress) {
            // Import error
            if (nextProps.importError) {
                this.props.notify({
                    title: this.props.intl.formatMessage({ id: 'alerts.titles.error' }),
                    message: nextProps.importError,
                    position: 'tc',
                }, 'error')

                this.importProcessing = false

                return false;
            }
            else if (this.state.step === 1) {
                const headers = nextProps.importHeaders.valueSeq().toArray()
                const defaultHeaders = nextProps.importDefaultHeaders.toJS()
                const columnTypes = {}

                nextProps.importHeaders.map((headerName, headerId) => {
                    if (defaultHeaders[headerName]) {
                        columnTypes[headerId] = defaultHeaders[headerName]
                    }

                    return false;
                })

                this.setState({
                    ...this.state,
                    step: 2,
                    importHeaders: headers,
                    importFileId: nextProps.importFileId,
                    importFileName: nextProps.importFileName,
                    columnTypes,
                })
            }
            else if (this.state.step >= 2) {
                if (this.importProcessing) {
                    this.props.notify({
                        title: this.props.intl.formatMessage({ id: 'alerts.titles.success' }),
                        message: this.props.intl.formatMessage({ id: 'alerts.messages.importSuccess' }),
                        position: 'tc',
                    }, 'success')

                    this.props.redirect('/customers/')
                }

                const items = nextProps.importItems
                const itemValues = []

                items.map((item, key) => {
                    itemValues[key] = item.name ? true : false
                })
                this.setState({
                    ...this.state,
                    step: 3,
                    importItems: items,
                    importItemValues: itemValues,
                })
            }
        }
    }

    /* eslint-disable jsx-a11y/anchor-is-valid */
    render() {
        document.title = formatters.titleFormatter(this.props.intl.formatMessage({ id: 'modules.customersImport.heading' }))

        const columnTypesOptions = Object.keys(this.columnTypes).map(id => ({
            id: id,
            name: this.columnTypes[id],
        }))

        columnTypesOptions.unshift({
            id: null,
            name: '-'
        })

        return (<PermissionsCheck has={[PERMS.CREATE]} noPermissionsPage>
                <div className={'page-inner '+(document.body.classList.contains('mobile-menu-open') ? 'sidebar-visible' : '')}>
                    <div id="main-wrapper">
                        <div className="row hp-100">
                            <div className={this.state.step <= 2 ? 'col-md-12 col-xl-8 col-xl-offset-2' : 'col-md-12 col-xl-12'}>
                                <LoadingOverlay active={this.props.importInProgress}>
                                    <div className="panel panel-white">
                                        <div className="panel-body panel-padding">
                                            <h4>
                                                <FormattedMessage id="modules.customersImport.heading" /> - <FormattedMessage id="modules.customersImport.step" /> {this.state.step}/3 ({this.stepNames[this.state.step]})
                                            </h4>

                                            {this.state.step === 1 && (<div className="wp-100 pull-left clearfix">
                                                <p className="m-b-lg">
                                                    <FormattedMessage id="import.step1" />
                                                </p>
                                                <Dropzone onDrop={this.onDropFiles} multiple={false} style={{}} className="dropzone" acceptClassName="dropzone-accept">
                                                    <p className="ready">
                                                        <FormattedMessage id="fields.dropzoneReady" />
                                                    </p>
                                                    <p className="accept">
                                                        <FormattedMessage id="fields.dropzoneAccept" />
                                                    </p>
                                                </Dropzone>
                                            </div>)}

                                            {this.state.step === 2 && (<div className="wp-100 pull-left clearfix">
                                                <p className="m-b-lg">
                                                    <FormattedMessage id="import.step2" />
                                                </p>

                                                <div className="row">
                                                    <div className="col-sm-6">
                                                        {Object.keys(this.state.importHeaders).map(headerId => {
                                                            let headerName = this.state.importHeaders[headerId]
                                                            if(!headerName){
                                                                return
                                                            }
                                                            return <div key={headerId}>
                                                                <SelectField
                                                                    id={headerId}
                                                                    label={headerName}
                                                                    readonly={() => false}
                                                                    values={columnTypesOptions}
                                                                    value={this.state.columnTypes[headerId]}
                                                                    onChange={e => {
                                                                        this.setColumnType(headerId, e.value)
                                                                    }}
                                                                />
                                                            </div>
                                                        })}
                                                    </div>
                                                </div>
                                            </div>)}

                                            {this.state.step === 3 && (<div className="wp-100 pull-left clearfix">
                                                <p className="m-b-lg">
                                                    <FormattedMessage id="import.step3" />
                                                </p>

                                                {!this.state.importItems.length && (<div className="alert alert-danger">
                                                    <p>
                                                        <FormattedMessage id="import.noItemsFound" />
                                                    </p>
                                                </div>)}

                                                {this.state.importItems.length && (<div>

                                                    <div className="table-container">
                                                    <table className="table table-striped">
                                                        <thead>
                                                        <tr>
                                                            <th className="w-40 text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    id={'item-all'}
                                                                    onChange={(e) => {
                                                                        this.onImportAllItemsChange(e.target.checked)
                                                                    }}
                                                                    checked={this.state.importAllItemsChecked}
                                                                />
                                                            </th>
                                                            <th className="w-90">
                                                                {this.columnTypes.vatNumber}
                                                            </th>
                                                            <th className="w-120">
                                                                {this.columnTypes.regNumber}
                                                            </th>
                                                            <th className="w-300">
                                                                {this.columnTypes.name}
                                                            </th>
                                                            <th className="w-180">
                                                                {this.columnTypes.nameTransporeon}
                                                            </th>
                                                            <th className="w-60 text-right">
                                                                {this.columnTypes.defaultCurrency}
                                                            </th>
                                                            <th className="w-70 text-right">
                                                                {this.columnTypes.invoiceDeadlineDays}
                                                            </th>
                                                            <th className="w-100">
                                                                {this.columnTypes.emailForInvoicing}
                                                            </th>
                                                            <th className="w-160">
                                                                {this.columnTypes.invoicingNote}
                                                            </th>
                                                            <th className="w-100 text-right">
                                                                {this.columnTypes.limitUnpaidInvoices}
                                                            </th>
                                                            <th className="w-100 text-right">
                                                                {this.columnTypes.limitOverdueInvoices}
                                                            </th>
                                                            <th className="w-70 text-center">
                                                                {this.columnTypes.blocked}
                                                            </th>
                                                            <th className="w-160">
                                                                {this.columnTypes.businessManager}
                                                            </th>
                                                            <th className="w-160">
                                                                {this.columnTypes.dispatcher}
                                                            </th>
                                                            <th className="w-60 text-right">
                                                                {this.columnTypes.transportPlanCount}
                                                            </th>
                                                            <th className="w-60 text-right">
                                                                {this.columnTypes.transportPlanValue}
                                                            </th>
                                                            <th className="w-60 text-right">
                                                                {this.columnTypes.transportPlanMargin}
                                                            </th>
                                                            <th className="w-60 text-right">
                                                                {this.columnTypes.speditionPlanCount}
                                                            </th>
                                                            <th className="w-60 text-right">
                                                                {this.columnTypes.speditionPlanValue}
                                                            </th>
                                                            <th className="w-60 text-right">
                                                                {this.columnTypes.speditionPlanMargin}
                                                            </th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {this.state.importItems.map((item, key) => {
                                                            return (<tr key={'importItem-' + key}>
                                                                <td className="text-center">
                                                                    <input
                                                                        type="checkbox"
                                                                        id={'item-' + key}
                                                                        onChange={(e) => {
                                                                            this.onImportItemChange(key, e.target.checked)
                                                                        }}
                                                                        disabled={!item.name}
                                                                        checked={this.state.importItemValues[key]}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    {item.regNumber}
                                                                </td>
                                                                <td>
                                                                    {item.vatNumber}
                                                                </td>
                                                                <td>
                                                                    {item.name}
                                                                </td>
                                                                <td>
                                                                    {item.nameTransporeon}
                                                                </td>
                                                                <td className="text-right">
                                                                     {item.defaultCurrency && (<div>
                                                                        {item.defaultCurrency} {formatters.boolFormatter(item.defaultCurrencyId ? 1 : 0)}
                                                                    </div>)}
                                                                </td>
                                                                <td className="text-right">
                                                                    {item.invoiceDeadlineDays}
                                                                </td>
                                                                <td>
                                                                    {item.emailForInvoicing}
                                                                </td>
                                                                <td>
                                                                    {item.invoicingNote}
                                                                </td>
                                                                <td className="text-right">
                                                                    {item.limitUnpaidInvoices}
                                                                </td>
                                                                <td className="text-right">
                                                                    {item.limitOverdueInvoices}
                                                                </td>
                                                                <td className="text-center">
                                                                    {formatters.boolFormatter(item.blocked)}
                                                                </td>
                                                                <td>
                                                                    {item.businessManager && (<div>
                                                                        {item.businessManager} {formatters.boolFormatter(item.businessManagerId ? 1 : 0)}
                                                                    </div>)}
                                                                </td>
                                                                <td>
                                                                    {item.dispatcher && (<div>
                                                                        {item.dispatcher} {formatters.boolFormatter(item.dispatcherId ? 1 : 0)}
                                                                    </div>)}
                                                                </td>
                                                                <td className="text-right">
                                                                    {item.transportPlanCount}
                                                                </td>
                                                                <td className="text-right">
                                                                    {item.transportPlanValue}
                                                                </td>
                                                                <td className="text-right">
                                                                    {item.transportPlanMargin}
                                                                </td>
                                                                <td className="text-right">
                                                                    {item.speditionPlanCount}
                                                                </td>
                                                                <td className="text-right">
                                                                    {item.speditionPlanValue}
                                                                </td>
                                                                <td className="text-right">
                                                                    {item.speditionPlanMargin}
                                                                </td>
                                                            </tr>)
                                                        })}
                                                        </tbody>
                                                    </table>
                                                    </div>
                                                </div>)}
                                            </div>)}

                                            <div className="pull-left wp-100 btns-form">
                                                {this.state.step > 1 && (
                                                    <button onClick={this.onBackButtonClick} className="btn btn-addon btn-default">
                                                        <i className="far fa-chevron-left" /> <FormattedMessage id="buttons.back" />
                                                    </button>)}

                                                {this.state.step === 2 && (
                                                    <button onClick={this.onSummaryButtonClick} className="btn btn-addon btn-success pull-right">
                                                        <i className="far fa-chevron-right" /> <FormattedMessage id="buttons.continue" />
                                                    </button>)}

                                                {this.state.step === 3 && (
                                                    <button onClick={this.onImportButtonClick} className="btn btn-addon btn-success pull-right">
                                                        <i className="far fa-check" /> <FormattedMessage id="buttons.import" />
                                                    </button>)}
                                            </div>
                                        </div>
                                    </div>
                                </LoadingOverlay>
                            </div>
                        </div>
                    </div>
                </div>
            </PermissionsCheck>)
    }
}

function mapStateToProps(state) {
    return {
        importInProgress: selectors.getImportInProgress(state),
        importError: selectors.getImportError(state),
        importFileId: selectors.getImportFileId(state),
        importHeaders: selectors.getImportHeaders(state),
        importDefaultHeaders: selectors.getImportDefaultHeaders(state),
        importItems: selectors.getImportItems(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            ...bindActionCreators({
                ...customersActionCreators
            }, dispatch),
        },
        notify: (notification, type) => dispatch(Notifications.show(notification, type)),
        redirect: toURL => dispatch(push(toURL)),
        dispatch,
    }
}

function mergeProps(stateProps, dispatchProps, ownProps) {
    return {
        ...stateProps, ...dispatchProps, ...ownProps
    }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps, mergeProps)(CustomersImport))
